module.exports = __webpack_public_path__ + "img/portrait_ada.a30f2128.jpg";